
import { daughterData } from '../lib/data';
import styles from './Daughter.module.scss';


const Daughter = () => {


    return ( 
        <section >
       
            <div className = {styles.container}>   
                {daughterData.map(({id, photo}) => (
                    <div className = {styles.container__photo} key={id}> 
                    <img  className={styles.photo} src={photo} alt="мама и дочь фото Ставрополь"/>
            </div>
            ))}
               
            </div>
</section>
    );
}
export default Daughter;